module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    class: _vm.sidebarOpen === true ? ' sidebar-open' : ''
  }, [_c('header', {
    staticClass: "main-header"
  }, [_c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "data-toggle": "push-menu",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sidebarToggle()
      }
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])]), _vm._v(" "), _c('sidebar', {
    attrs: {
      "display-name": _vm.demo.displayName,
      "picture-url": _vm.demo.avatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n        " + _vm._s(_vm.$route.name.toUpperCase()) + "\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])])]), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-050b5430!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dash.vue
// module id = 2076
// module chunks = 2